// extracted by mini-css-extract-plugin
module.exports = {"btn":"Button_btn__iWxTL"};